<div class="access-title">
	<div>Correo electrónico</div>
	<div class="arrow__icon" [ngClass]="( isCollapsed$ | async )? '': 'expanded'" (click)="toggleCollapse( $event )" gtagEvent="colapsar" gtagCategory="correo-electronico-widget">
		<span></span>
		<span></span>
	</div>
</div>

<div [@smoothCollapse]="( isCollapsed$ | async )? 'collapsed': 'expanded'">

	<!-- Email Personal -->
	<ng-container *ngIf="( personal$ | async ) as email">
		<div class="access-content" (click)="openEmailPersonal( email )">
			<div class="access-content__data-icon" [ngStyle]="getEmailStyle()"><div class="email__icon email__personal-icon"></div></div>
			<div class="access-content__data email-data" [ngStyle]="getEmailStyle()">{{email.emailAbreviado}}</div>
		</div>
	</ng-container>

	<!-- Emails Delegados -->
	<ng-container *ngIf="( delegados$ | async ) as delegados">
		<ng-container *ngFor="let email of delegados">
			<div class="access-content" [ngClass]="{ 'highlight-access': email.markedFromUI }" (click)="openEmailDelegado( email )">
				<div class="access-content__data-icon" [ngStyle]="getEmailStyle()"><div class="email__icon email__delegado-icon"></div></div>
				<div class="access-content__data email-data" [ngStyle]="getEmailStyle()">{{email.emailAbreviado}}</div>
			</div>
		</ng-container>
	</ng-container>

	<div class="access-more-info access-see-all" routerLink="/principal/correos-electronicos" gtagEvent="ver-todos" gtagCategory="correo-electronico-widget">Ver Todos</div>

</div>
